import { KeyboardEvent, Ref, useState } from 'react';
import { Search as SearchIcon } from 'lucide-react';

import { TranslationsKeys, useTranslate } from 'hooks/useTranslate';
import { TextInput } from '../TextInput';

interface IProps {
  variant?: 'full' | 'inline';
  disabled?: boolean;
  inputRef?: Ref<HTMLInputElement>;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onChange: (value: string) => void;
}

export const SearchInput = ({ variant = 'full', disabled, inputRef, onKeyDown, onChange }: IProps): JSX.Element => {
  const { t } = useTranslate();
  const [query, setQuery] = useState<string>('');

  return (
    <div>
      <TextInput
        state={disabled ? 'disabled' : undefined}
        text={query}
        onKeyDown={onKeyDown as ((e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void)}
        onChange={(e) => {
          const { value } = e.target;
          setQuery(value);
          onChange(value);
        }}
        inputRef={inputRef}
        {...(variant === 'inline'
          ? { prefixIcon: <SearchIcon /> }
          : { label: t(TranslationsKeys.common_search), suffixIcon: <SearchIcon /> })}
      />
    </div>
  );
};
